/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Updated_ToastInputs */

const en_branches_updated_toast = /** @type {(inputs: Branches_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch updated`)
};

const pt_br2_branches_updated_toast = /** @type {(inputs: Branches_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filial atualizada`)
};

/**
* | output |
* | --- |
* | "Branch updated" |
*
* @param {Branches_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_updated_toast = /** @type {((inputs?: Branches_Updated_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Updated_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_updated_toast(inputs)
	return pt_br2_branches_updated_toast(inputs)
});